<template>
  <div>
    <Transition name="fade" mode="out-in">
      <div v-if="addressCombo">
        <div class="w-full relative mb-4">
          <p class="font-bold mb-5">Start typing to find your address</p>
          <div v-ClickOutside="hideAll">
            <DrInput
              ref="addressInput"
              v-model="addressInput"
              class="mb-1"
              placeholder="Postcode"
              @focus="focus = true"
              @input="addressLookup(addressInput)"
            />
            <Transition name="fade">
              <div v-if="focus && addressInput.length" :class="{ 'p-8': loading }" class="combo-select">
                <DrLoader v-if="loading" />
                <div v-else-if="!loading && addresses.length">
                  <div class="combo-heading border-grey-150">Select your address below</div>
                  <div class="combo-list">
                    <div
                      v-for="address in addresses"
                      :key="address.Id"
                      class="combo-item border-grey-150"
                      tabindex="0"
                      @mousedown="retrieveAddress(address)"
                      @keydown.enter.prevent="retrieveAddress(address)"
                    >
                      <div class="combo-name font-normal">{{ address.Text }}</div>
                      <div v-if="address.Description" class="combo-meta">{{ address.Description }}</div>
                      <DrIcon svg="angle-right" width="25" height="25" class="combo-icon" />
                    </div>
                  </div>
                  <div class="combo-link">
                    <DrButton
                      class="btn-sm btn-outline btn-blue inline-block text-2xs"
                      @click.prevent="addressCombo = false"
                    >
                      I can't find my address
                    </DrButton>
                  </div>
                </div>
                <div v-else class="combo-error">No matches found.</div>
              </div>
            </Transition>
          </div>
        </div>
      </div>
      <div v-else>
        <AddressForm />
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ClickOutside from '../../directives/ClickOutside'
import AddressForm from './AddressForm.vue'
import axiosPostcodeanywhereApi from '@/services/axiosPostcodeanywhereApi'

export default {
  components: {
    AddressForm,
  },
  directives: {
    ClickOutside,
  },
  data () {
    return {
      addressCombo: true,
      focus: false,
      addressInput: '',
      debounceTimeout: null,
      addresses: [],
      loading: false,
    }
  },
  mounted () {
    this.$refs.addressInput.$refs.input.focus()
  },
  methods: {
    ...mapActions({
      storePremises: 'premises/storePremises',
    }),
    hideAll () {
      this.$refs.addressInput.$refs.input.blur()
      this.focus = false
    },
    async addressLookup (SearchTerm, LastId) {
      clearTimeout(this.debounceTimeout)
      this.loading = true
      this.debounceTimeout = await setTimeout(() => {
        axiosPostcodeanywhereApi
          .get(`Find/v1.00/json3.ws`, {
            params: {
              SearchTerm,
              LastId: LastId || null,
              SearchFor: 'Everything',
              Country: 'GBR',
              LanguagePreference: 'EN',
              MaxSuggestions: 7,
              MaxResults: 100,
            },
          })
          .then((response) => {
            this.loading = false
            this.addresses = response.data.Items
          })
      }, 500)
    },
    async retrieveAddress (address) {
      if (address.Next === 'Find') {
        this.addressLookup(address.Text, address.Id)
      } else if (address.Next === 'Retrieve') {
        await axiosPostcodeanywhereApi
          .get(`Retrieve/v2.10/json3.ws`, {
            params: {
              Id: address.Id,
            },
          })
          .then(async (response) => {
            this.loading = false
            await this.storePremises({
              quoteId: this.$store.state.quoteId,
              formData: {
                line1: response.data.Items[0].Line1,
                line2: response.data.Items[0].Line2,
                line3: response.data.Items[0].Line3,
                city: response.data.Items[0].City,
                country: response.data.Items[0].CountryName,
                postcode: response.data.Items[0].PostalCode,
              },
            }).then(() => {
              this.$router.push('/checkout/policyholder')
            })
          })
      }
    },
  },
}
</script>

<style scoped>
.combo-icon {
  color: theme('colors.blue.500');
}

.combo-item:hover .combo-icon,
.combo-item:focus .combo-icon {
  color: white;
}
</style>
